export default {
  label: 'Cobrar el cargo por servicio en los pedidos en mesa',
  description: 'Los pedidos en mesa no pagan cargo por servicio si esto no está activado.',
  no_fee: 'Tu restaurante no cobra tarifa de servicio, así que los pedidos en mesa tampoco pagan ninguna.',
  partner_default_on: 'Predeterminado del partner: activado',
  partner_default_off: 'Predeterminado del partner: desactivado',
  toasts: {
    on: 'Ahora los pedidos en mesa pagan el cargo por servicio',
    off: 'Ahora los pedidos en mesa no pagan cargo por servicio',
    error: 'No se guardó. Inténtalo de nuevo.',
  },
};
